import { nanoid } from 'nanoid'
import { type ReactNode } from 'react'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { IconButton } from 'shared/ui'
import styles from '../styles.module.scss'

export const mobilePreviewModal = (children: ReactNode) => {
  const id = nanoid()

  const onCloseModal = () => {
    modalStore.closeModal(id)
  }

  modalStore.addModal({
    id: id,
    type: 'right',
    contentStyle: {
      width: 380,
    },
    content: (
      <>
        <div className={styles.header}>
          <IconButton
            ariaLabel={'mobilePreviewBtn'}
            icon={'close'}
            variant={'icon'}
            color={'secondary'}
            onClick={onCloseModal}
          />
        </div>
        <div className={styles.wrapPreview}>{children}</div>
      </>
    ),
  })
}
